<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="formgrid grid p-fluid">
    <div class="field col-12">
      <p class="font-normal text-600 m-0">
        <span class="text-primary font-medium">TAKE NOTE:</span> This links an existing,
        already-provisioned circuit (e.g. from a field install or TOC submission that hasn't been
        connected to a subscription yet) to this customer. The circuit's own number is kept
        exactly as installed - this subscription's account reference (currently
        <strong>{{ subscription?.subscription_account_reference }}</strong>) will change to match
        it. If the subscription is still pending activation, it will be activated immediately.
        This does not create a new circuit - if one doesn't already exist for this customer, use
        Swop Device / Operations instead.
      </p>
    </div>

    <div class="field col-12">
      <label for="device_reference">Circuit Number or Device Serial</label>
      <input
        id="device_reference"
        type="text"
        pInputText
        formControlName="device_reference"
        placeholder="Circuit number or device serial"
        class="w-full"
      />
      <small
        class="p-error"
        *ngIf="form.get('device_reference')?.invalid && form.get('device_reference')?.touched"
        >Please enter a circuit number or device serial</small
      >
    </div>

    <div class="field col-12">
      <button
        pButton
        type="submit"
        label="Claim Circuit"
        class="p-button p-button-success"
        [loading]="submitting"
      ></button>
    </div>

    <div class="field col-12">
      <p-message
        *ngIf="errorMessage !== ''"
        severity="error"
        [text]="errorMessage"
        class="w-full"
      ></p-message>
    </div>
  </div>
</form>
